import { Route, Switch } from 'wouter'

import { Dropbox } from './dropbox/Dropbox'
import { Contractors } from './contractors/Contractors'
import { Placements } from './placements/Placements'
import { PhaseManagement } from './phase-management/PhaseManagement'
import { Portal } from './intranet/Portal'
import { Login } from './intranet/Login'
import { ChristmasGifts } from './christmas-gifts/ChristmasGifts'
import { CopraManagementTool } from './copra-management-tool/CopraManagementTool'

export const IntranetTools = () => {
  return (
    <Switch>
      <Route path="/" component={Portal} />
      <Route path="/login" component={Login} />
      <Route path="/dropbox" component={Dropbox} />
      <Route path="/contractors" component={Contractors} />
      <Route path="/placements" component={Placements} />
      <Route path="/phase-management" component={PhaseManagement} />
      <Route path="/christmas-gifts" component={ChristmasGifts} />
      <Route path="/copra-management-tool" component={CopraManagementTool} />
    </Switch>
  )
}
